const LocalStorageKeys = {
  credentials: 'CSWA_CREDENTIALS',
}

/** Public file store the requirements file is loaded from. */
const PublicFilesUrl = 'https://mobileupdate.infominds.eu/api/PublicFiles?requestedFileName='
/** Name of the requirements file with the app information. */
const RequirementsFileName = 'requirements-mobile.json'
/** Base URL for the relative icon paths in the requirements file. */
const RequirementsImagesUrl = 'https://mobile.infominds.eu/requirements/'

export { LocalStorageKeys, PublicFilesUrl, RequirementsFileName, RequirementsImagesUrl }
